module.exports = __webpack_public_path__ + "img/cms_overview.1078bf41.png";